export default function Home() {
  return (
    <div>
      <h1>Footprint Finder</h1>
      <p>
        The FootprintFinder uses justenergy.com's calculation to detail your
        yearly Carbon contribution. Carbon FootPrint is measured in pounds per
        year, and our calculator has three levels - Low, Average and High.
      </p>
    </div>
  );
}
